var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p class=\"footer__links\">\n  <a href=\"https://teams.szn.cz/vyhledavani/channels/adminproxy\">\n      Podpora v Teams\n  </a>\n</p>\n";
},"useData":true});